/**
 * フォームフィールドのラベル右脇に表示する「必須」「任意」補助テキストの解決ヘルパ。
 *
 * Input / NumberInput / ComboInput / DateInput / Calendar 等で
 *   <span className={className}>{text}</span>
 * の形で共通利用する。
 *
 * 設計意図:
 *  - 呼び出し側の表記揺れ（"[必須]" / "必須" / "required" / "[required]" など）を
 *    内部で吸収し、常に「必須」「任意」テキスト + 色（青 / 薄グレー）で表示する。
 *  - 新規コードは {@link FieldOption} の union 型を渡すこと。
 */
export type FieldOption = "required" | "optional";

export interface ResolvedOptionLabel {
  /** 表示テキスト。空文字なら表示しない。 */
  text: string;
  /** ラベル右脇 span に付ける className。 */
  className: string;
}

const EMPTY: ResolvedOptionLabel = { text: "", className: "" };

export const resolveOptionLabel = (
  option?: string | null,
): ResolvedOptionLabel => {
  if (!option) return EMPTY;
  const isRequired = option.includes("必須") || option.includes("required");
  const isOptional = option.includes("任意") || option.includes("optional");
  if (!isRequired && !isOptional) return EMPTY;
  const text = isRequired ? "必須" : "任意";
  const color = isRequired ? "u-text-blue" : "u-text-light-gray";
  return {
    text,
    className: `label8 u-pl8 ${color}`,
  };
};
